import type { Components } from '@mui/material';
import { horizonTheme } from './horizon-theme';

export const muiTab: Components<typeof horizonTheme>['MuiTab'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      textTransform: 'capitalize',
      padding: 0,

      '&.MuiButtonBase-root': {
        outline: 'none',
        color: theme.palette.red.main,
      },

      '&.MuiButtonBase-root:focus-visible': {
        outline: 'none',
      },
    }),
  },
};
